<template>
  <OnboardingSubLayout :is-loading="isLoading">
    <OnboardingContainer
      :class="classes"
      :display-clearco-logo="true"
      :percent-complete="percentComplete"
    >
      <template #title>
        <div :class="$style['text']">{{ title }}</div>
      </template>
      <template v-if="subtitle" #subtitle>
        <div :class="$style['text']">
          {{ subtitle }}
          <template v-if="subtitleCta">
            <a
              v-if="subtitleCta.link"
              :href="subtitleCta.href"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ subtitleCta.link }}
            </a>
          </template>
        </div>
      </template>
      <RouterView />
    </OnboardingContainer>
  </OnboardingSubLayout>
</template>

<script>
import { mapGetters } from 'vuex';

import sendUtmParamsToSegment from '@/composables/utm';

import OnboardingContainer from '@/components/OnboardingContainer.vue';
import OnboardingSubLayout from '@/pages/onboarding/components/OnboardingSubLayout.vue';

export default {
  components: {
    OnboardingContainer,
    OnboardingSubLayout,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters([
      'paymentsOnboardingSteps',
      'isEmailVerified',
      'invitedUserOnboardingSteps',
      'user',
    ]),
    classes() {
      return {
        [this.$style['onboarding-wrapper']]: !this.authPage,
      };
    },
    currentRoute() {
      return this.$route.name;
    },
    authPage() {
      return this.$route.meta?.requiresAuth;
    },
    percentComplete() {
      return this.currentStep?.percentComplete;
    },
    currentStep() {
      return this.user.isPrimary
        ? this.paymentsOnboardingSteps[this.currentRoute]
        : this.invitedUserOnboardingSteps[this.currentRoute];
    },
    title() {
      return this.currentStep.title;
    },
    subtitle() {
      return this.verificationMessage ?? this.currentStep?.subtitle;
    },
    subtitleCta() {
      return this.currentStep?.subtitleCta;
    },
    verificationMessage() {
      return this.isEmailVerified
        ? 'Your email has been verified. Please complete your business profile.'
        : undefined;
    },
  },
  setup() {
    return sendUtmParamsToSegment();
  },
  async beforeMount() {
    this.isLoading = false;
  },
};
</script>

<style lang="less" module>
.onboarding-wrapper {
  [class^='content-container'] {
    margin-top: unset;
  }
  @media only screen and (min-width: 961px) {
    max-width: 460px !important;
  }
}

.text {
  text-align: center;
}
</style>
